export default {
      id: "telegram-list-item-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite-46b249.svg#telegram-list-item-usage",
      toString: function () {
        return this.url;
      }
    }